//#region src/schema/localization/locales/en.ts
var e = {
	schema: {
		noAllowedValues: "No values satisfy this enum constraint.",
		example: "Example",
		examples: "Examples",
		default: "Default",
		schema: "Schema",
		emptyObject: "Empty object",
		showAdditionalProperties: "Show additional properties",
		showOneMoreProperty: "Show 1 more property",
		showMoreProperties: "Show {count} more properties",
		forName: "for {name}",
		showSchemaDetails: "Show Schema Details",
		oneOf: "One of",
		variants: "Variants",
		discriminatorValue: "Discriminator value",
		anyOf: "Any of",
		allOf: "All of",
		not: "Not",
		unknownType: "unknown type",
		propertyCount: "Properties: {count}",
		headerCount: "Headers: {count}",
		recursiveReference: "Recursive reference to {name}",
		recursive: "recursive",
		additionalProperties: "additional properties",
		const: "const",
		deprecated: "deprecated",
		discriminator: "Discriminator",
		enum: "enum",
		format: "Format",
		greaterThan: "greater than",
		keys: "keys",
		lessThan: "less than",
		max: "max",
		min: "min",
		maxLength: "max length",
		minLength: "min length",
		multipleOf: "multiple of",
		nullable: "nullable",
		propertyNames: "property names",
		pattern: "Pattern",
		copyPattern: "Copy pattern",
		readOnly: "read-only",
		required: "required",
		hideValues: "Hide values",
		showAllValues: "Show all values",
		type: "Type",
		unique: "unique",
		values: "values",
		writeOnly: "write-only",
		typeInteger: "Integer numbers.",
		formatInt32: "Signed 32-bit integers (commonly used integer type).",
		formatInt64: "Signed 64-bit integers (long type).",
		formatDate: "full-date notation as defined by RFC 3339, section 5.6, for example, 2017-07-21",
		formatDateTime: "the date-time notation as defined by RFC 3339, section 5.6, for example, 2017-07-21T17:32:28Z",
		formatPassword: "a hint to UIs to mask the input",
		formatBase64: "base64-encoded characters, for example, U3dhZ2dlciByb2Nrcw==",
		formatBinary: "binary data, used to describe files"
	},
	common: {
		copyDefault: "Copy default value",
		copyExample: "Copy example value"
	},
	actions: { copyLinkTo: "Copy link to {name}" }
};
//#endregion
export { e as en };

//# sourceMappingURL=en.js.map